import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _cloneServiceOptionsAndVariantsRequest = {};
var _cloneServiceOptionsAndVariantsResponse = {};
var _createServiceOptionsAndVariantsRequest = {};
var _createServiceOptionsAndVariantsResponse = {};
var _deleteServiceOptionsAndVariantsRequest = {};
var _deleteServiceOptionsAndVariantsResponse = {};
var _getServiceOptionsAndVariantsByServiceIdRequest = {};
var _getServiceOptionsAndVariantsByServiceIdResponse = {};
var _getServiceOptionsAndVariantsRequest = {};
var _getServiceOptionsAndVariantsResponse = {};
var _queryServiceOptionsAndVariantsRequest = {};
var _queryServiceOptionsAndVariantsResponse = {};
var _updateServiceOptionsAndVariantsRequest = {
    mask: 'google.protobuf.FieldMask',
};
var _updateServiceOptionsAndVariantsResponse = {};
function resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/v1/serviceOptionsAndVariants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/bookings/v1/service-options-and-variants',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/v1/serviceOptionsAndVariants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/bookings/v1/service-options-and-variants',
                destPath: '/api',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/bookings/v1/service-options-and-variants',
                destPath: '/api',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
            {
                srcPath: '/_api/bookings/v1/service-options-and-variants',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/serviceOptionsAndVariants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/v1/service-options-and-variants',
                destPath: '/v1/serviceOptionsAndVariants',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates options and variants for a service.
 *
 * Before creating the `serviceOptionsAndVariants` object you need to anticipate and manually define
 * all variants based on the defined options and their choices. You then pass
 * the `options` and `variants` arrays in the
 * request. Variants aren't automatically calculated from the defined options and choices.
 *
 * __Current Limitations:__
 *
 * + Only a single `serviceOptionsAndVariants` object is supported per service.
 *
 * + Only a single option is supported per `serviceOptionsAndVariants` object. This means that services are limited to a single option. Therefore, `variants`provides pricing details for either all choices of the single option (for `CUSTOM` options) or all staff members providing the service (for `STAFF_MEMBER` options).
 *
 * For a list of error messages, see [Create Service Options and Variants Errors](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/error-messages#service-options-and-variants_error-messages_create-service-options-and-variants-errors).
 */
export function createServiceOptionsAndVariants(payload) {
    var _a = serializer(_createServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __createServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'POST',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.CreateServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createServiceOptionsAndVariants.fromReq = fromReq;
    __createServiceOptionsAndVariants.__isAmbassador = true;
    return __createServiceOptionsAndVariants;
}
/**
 * Clones a `serviceOptionsAndVariants` object. This endpoint can be called, for example, to duplicate a service.
 * The cloned service contains all the original service options and variants.
 *
 * Each option
 * in the cloned service has a newly-generated ID that is copied to all choices of the variants in the
 * clone. The cloned service references the service provided in the request by `target_service_id`.
 */
export function cloneServiceOptionsAndVariants(payload) {
    var _a = serializer(_cloneServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __cloneServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'POST',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.CloneServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/{cloneFromId}/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneServiceOptionsAndVariants.fromReq = fromReq;
    __cloneServiceOptionsAndVariants.__isAmbassador = true;
    return __cloneServiceOptionsAndVariants;
}
/** Retrieves a `serviceOptionsAndVariants` object by `service_options_and_variants_id`. */
export function getServiceOptionsAndVariants(payload) {
    var _a = serializer(_getServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __getServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'GET',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.GetServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/{serviceOptionsAndVariantsId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                        protoPath: '/v1/serviceOptionsAndVariants/{serviceOptionsAndVariantsId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getServiceOptionsAndVariants.fromReq = fromReq;
    __getServiceOptionsAndVariants.__isAmbassador = true;
    return __getServiceOptionsAndVariants;
}
/** Retrieves a service's options and variants by `service_id`. */
export function getServiceOptionsAndVariantsByServiceId(payload) {
    var _a = serializer(_getServiceOptionsAndVariantsByServiceIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getServiceOptionsAndVariantsByServiceIdResponse, {}).fromJSON;
    function __getServiceOptionsAndVariantsByServiceId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'GET',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.GetServiceOptionsAndVariantsByServiceId',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/service_id/{serviceId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                        protoPath: '/v1/serviceOptionsAndVariants/service_id/{serviceId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getServiceOptionsAndVariantsByServiceId.fromReq = fromReq;
    __getServiceOptionsAndVariantsByServiceId.__isAmbassador = true;
    return __getServiceOptionsAndVariantsByServiceId;
}
/**
 * Updates the specified fields of the `serviceOptionsAndVariants` object.
 *
 * Currently, only a single option is supported per `serviceOptionsAndVariants` object.
 *
 * If you want to update `variants`, you must pass the full list of supported variants.
 *
 * If you want to update `options`, you must pass the full list of supported options.
 *
 * For a list of error messages, see [Update Service Options and Variants Errors](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/error-messages#service-options-and-variants_error-messages_update-service-options-and-variants-errors).
 */
export function updateServiceOptionsAndVariants(payload) {
    var _a = serializer(_updateServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __updateServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'PATCH',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.UpdateServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/{serviceOptionsAndVariants.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateServiceOptionsAndVariants.fromReq = fromReq;
    __updateServiceOptionsAndVariants.__isAmbassador = true;
    return __updateServiceOptionsAndVariants;
}
/**
 * Deletes a `serviceOptionsAndVariants` object.
 *
 *
 * Because each service has only a single `serviceOptionsAndVariants` object, the
 * service won't have any supported options and variants any longer. Instead,
 * the standard Wix Bookings service price calculation is used.
 */
export function deleteServiceOptionsAndVariants(payload) {
    var _a = serializer(_deleteServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __deleteServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'DELETE',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.DeleteServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/{serviceOptionsAndVariantsId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteServiceOptionsAndVariants.fromReq = fromReq;
    __deleteServiceOptionsAndVariants.__isAmbassador = true;
    return __deleteServiceOptionsAndVariants;
}
/**
 * Retrieves a list of `serviceOptionsAndVariants`, given the provided paging, filtering, and sorting.
 *
 * Query Service Options And Variants runs with these defaults, which you can override:
 *
 * - `id` is sorted in `ASC` order
 * - `cursorPaging.limit` is `100`
 *
 * For a detailed list of supported filtering operations see
 * [supported filters](https://dev.wix.com/api/rest/wix-bookings/service-options-and-variants/supported-filters).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryServiceOptionsAndVariants(payload) {
    var _a = serializer(_queryServiceOptionsAndVariantsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryServiceOptionsAndVariantsResponse, {}).fromJSON;
    function __queryServiceOptionsAndVariants(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.catalog.v1.service_options_and_variants',
            method: 'POST',
            methodFqn: 'wix.bookings.catalog.v1.ServiceOptionsAndVariantsService.QueryServiceOptionsAndVariants',
            url: resolveWixBookingsCatalogV1ServiceOptionsAndVariantsServiceUrl({
                protoPath: '/v1/serviceOptionsAndVariants/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryServiceOptionsAndVariants.fromReq = fromReq;
    __queryServiceOptionsAndVariants.__isAmbassador = true;
    return __queryServiceOptionsAndVariants;
}
//# sourceMappingURL=http.impl.js.map